import {
	he,
	ico_he,
	picture_convert,
	reels_lenghts, reels_pos,
	server_config, behavior_config,
	wi
} from "../framework/src/engine/madnes/madnes_variables";
import {
	madnes_add_group,
	madnes_add_img,
	madnes_add_sprite,
	madnes_add_to_group, madnes_set_img_center, madnes_set_pos, madnes_set_pos_x, madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {madnes_anim_add, madnes_anim_loop, madnes_anim_play} from "../framework/src/engine/madnes/madnes_anims";
import {stopposin, stopposin_old} from "./mv81_core";
import {cylinder_pos} from "./mv81_config";
import {bet, madnes_fill_range,  madnes_get_json} from "../framework/src/engine/madnes/madnes";
import {
	madnes_add_bitmap_text,
	madnes_add_text,
	madnes_set_bitmap_float
} from "../framework/src/engine/madnes/madnes_text";
import {madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";
import {main_phaser, wintable_phaser} from "../framework/src/engine/madnes/MadnesApp";

// Vytvoreni potrebnych onjektu z nactenych textur.
export function mv81_print_desk()
{
	if(typeof behavior_config.reel.spin.motionBlur == "undefined")
	{
		behavior_config.reel.spin.motionBlur = 1;
	}
	
	if(typeof behavior_config.reel.spin.timeToReachFullSpeed == "undefined")
	{
		behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
		if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
		{
			behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
		}
	}
	
	if(typeof behavior_config.reel.spin.timeToReachNullSpeed == "undefined")
	{
		behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
		if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
		{
			behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
		}
	}
	
	//behavior_config.reel.spin.timeToReachNullSpeed = 0;
	
	if(typeof behavior_config.reel.acceleration.moveTime != "undefined")
	{
		behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.moveTime;
	}
	
	if(typeof behavior_config.reel.brake.moveTime != "undefined")
	{
		behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.brake.moveTime;
	}
	
	if(behavior_config.reel.spin.timeToReachFullSpeed == 0)
	{
		behavior_config.reel.spin.timeToReachFullSpeed = 0.01;
	}
	
	if(behavior_config.reel.spin.timeToReachNullSpeed == 0)
	{
		behavior_config.reel.spin.timeToReachNullSpeed = 0.01;
	}
	
	if(behavior_config.reel.spin.timeToReachFullSpeed > 0.5)
	{
		behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
	}
	
	if(behavior_config.reel.spin.timeToReachNullSpeed > 0.5)
	{
		behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
	}
	/*
	behavior_config.reel.spin.timeToReachNullSpeed = 0.01;
	behavior_config.reel.spin.timeToReachFullSpeed = 0.01;
	behavior_config.reel.spin.commonSpeed = 28;
	
	behavior_config.reel.brake.brakeHeight = 0.01;
	behavior_config.reel.brake.keepTime = 0.01;
	behavior_config.reel.brake.moveBackTime = 0.01;
	behavior_config.reel.brake.moveTime = 0.01;
	
	behavior_config.reel.spin.delayBetweenReelStops = 0;
	*/
	// madnes_set_win_factors(
	// 	behavior_config.reel.minBigWinFactor,
	// 	behavior_config.reel.minMegaWinFactor,
	// 	behavior_config.reel.minSuperMegaWinFactor
	// );

	// if(
	// 	typeof server_config.logic != "undefined" &&
	// 	typeof server_config.logic.bet_set != "undefined"
	// )
	// {
	// 	//bets = server_config.logic.bet_set;
	// 	/*var bet0 = [];
	// 	for(var b in server_config.logic.bet_set)
	// 	{
	// 		if(
	// 			server_config.logic.bet_set[b] >= 10 &&
	// 			server_config.logic.bet_set[b] <= 100
	// 		)
	// 		{
	// 			bet0[bet0.length] = server_config.logic.bet_set[b];
	// 		}
	// 	}
	// 	bets = bet_set = bet0;*/
	//
	// 	bets = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
	// }
	
	madnes_add_img("background", "background", 0, -5);
	/*
	////////////////////////////////////////////////////////////////////////////////
    
    var style = { 
	 	font: "26px Arial", 
	 	fontWeight: "bold",
	 	fill: "#dd00cc", 
        align: "left",
        boundsAlignH: "left", 
        boundsAlignV: "top", 
        wordWrap: false, 
        wordWrapWidth: 300 
    };
	*/

	for(var i in server_config.logic.reels)
	{
		//server_config.logic.reels[i].splice(8);
	}
	
    // Nastaveni / vytvoreni pasu pro valce podle navratu ze serveru
	for(var i = 0; i < cylinder_pos.length; i++)
	{
		for(var j in server_config.logic.reels[i])
		{

			madnes_add_sprite("reels_bufer_" + i + "_" + j, picture_convert[server_config.logic.reels[i][j]] + "_blur", cylinder_pos[i], -9999);
			madnes_anim_add("reels_bufer_" + i + "_" + j, "blur", [0]);
			madnes_anim_add("reels_bufer_" + i + "_" + j, "stop", [1]);
			
			madnes_anim_play("reels_bufer_" + i + "_" + j, "stop");
			
			//madnes_add_text("text_reels_bufer_" + i + "_" + j, cylinder_pos[i], -999, "reels_bufer_" + i + "_" + j, style);
			//madnes_set_img_center("text_reels_bufer_" + i + "_" + j, 0, -2.5);
			
			reels_lenghts[i] = j * 1 + 1;
			stopposin[i] = reels_lenghts[i];
			stopposin_old[i] = reels_lenghts[i];
		}
		
		// S0-S2 = priprava vyherni pozice na kazdem valci
		madnes_add_sprite("reels_bufer_" + i + "_S0", 
			picture_convert[server_config.logic.failResult[i][2]] + "_blur", 
			cylinder_pos[i], 
			10);
			
		madnes_add_sprite("reels_bufer_" + i + "_S1", picture_convert[server_config.logic.failResult[i][1]] + "_blur", cylinder_pos[i], 10);
		madnes_add_sprite("reels_bufer_" + i + "_S2", picture_convert[server_config.logic.failResult[i][0]] + "_blur", cylinder_pos[i], 10);
		
		
		
		
		
		/*
		madnes_add_text("text_reels_bufer_" + i + "_S0", cylinder_pos[i], -999, "reels_bufer_" + i + "_S0", style);
		madnes_add_text("text_reels_bufer_" + i + "_S1", cylinder_pos[i], -999, "reels_bufer_" + i + "_S1", style);
		madnes_add_text("text_reels_bufer_" + i + "_S2", cylinder_pos[i], -999, "reels_bufer_" + i + "_S2", style);
		
		madnes_set_img_center("text_reels_bufer_" + i + "_S0", 0, -2.5);
		madnes_set_img_center("text_reels_bufer_" + i + "_S1", 0, -2.5);
		madnes_set_img_center("text_reels_bufer_" + i + "_S2", 0, -2.5);
		*/
		
		madnes_anim_add("reels_bufer_" + i + "_S0", "stop", [1]);
		madnes_anim_add("reels_bufer_" + i + "_S0", "blur", [0]);
		madnes_anim_add("reels_bufer_" + i + "_S1", "stop", [1]);
		madnes_anim_add("reels_bufer_" + i + "_S1", "blur", [0]);
		madnes_anim_add("reels_bufer_" + i + "_S2", "stop", [1]);
		madnes_anim_add("reels_bufer_" + i + "_S2", "blur", [0]);
		
		madnes_anim_play("reels_bufer_" + i + "_S0", "stop");
		madnes_anim_play("reels_bufer_" + i + "_S1", "stop");
		madnes_anim_play("reels_bufer_" + i + "_S2", "stop");

		reels_pos[i] = 0;
		
		stopposin[i] = Math.random() * ( reels_lenghts[i] / 2 );
		stopposin[i] = Math.floor(stopposin[i]);
		if(stopposin[i] == 0)
		{
			stopposin[i] = reels_lenghts[i];
		}
		stopposin_old[i] = stopposin[i];
		reels_pos[i] = stopposin[i] * ico_he;
	}
	
	
	madnes_add_img("reels_cover", "reels_cover", 0, 0);
	madnes_add_img("logo_reels", "logo_reels", wi / 2, 0, 1, 0.5, 0);
	
	madnes_add_img("cross1", "cross", 336, 276 - 12, 1, 0.5, 0.5);
	madnes_add_img("cross2", "cross", 336, 450 - 12, 1, 0.5, 0.5);
	madnes_add_img("cross3", "cross", 642, 276 - 12, 1, 0.5, 0.5);
	madnes_add_img("cross4", "cross", 642, 450 - 12, 1, 0.5, 0.5);
	madnes_add_img("cross5", "cross", 946, 276 - 12, 1, 0.5, 0.5);
	madnes_add_img("cross6", "cross", 946, 450 - 12, 1, 0.5, 0.5);
	madnes_add_group("crosses");
	madnes_add_to_group("crosses", "cross1");
	madnes_add_to_group("crosses", "cross2");
	madnes_add_to_group("crosses", "cross3");
	madnes_add_to_group("crosses", "cross4");
	madnes_add_to_group("crosses", "cross5");
	madnes_add_to_group("crosses", "cross6");
	
	madnes_add_img("reels_lights", "reels_lights", 0, 0, 0);
	
	madnes_add_img("winline_left",  "winline_left",   0, he / 2 - 28, 1, 0.53, 0.3);
	madnes_add_img("winline_right", "winline_right", wi, he / 2 - 28, 1, 0.47, 0.3);

	for(var i = 0; i < cylinder_pos.length; i++)
	{
		madnes_add_sprite("reels_bufer_" + i + "_TMP0", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
		madnes_add_sprite("reels_bufer_" + i + "_TMP1", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
		madnes_add_sprite("reels_bufer_" + i + "_TMP2", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
		
		madnes_add_sprite("reels_bufer_" + i + "_TMP20", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
		madnes_add_sprite("reels_bufer_" + i + "_TMP21", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
		madnes_add_sprite("reels_bufer_" + i + "_TMP22", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
	}
	
	
	madnes_add_sprite("bigwin_sprite", "bigwin_sprite", -9999, -9999, 1, 0.5, 0.5);
	madnes_anim_add("bigwin_sprite", "stop", [0]);
	madnes_anim_add("bigwin_sprite", "anim", madnes_fill_range(0,20));
	madnes_anim_loop("bigwin_sprite", "anim");
	
	madnes_add_sprite("bigwin", "bigwin", -9999, -9999, 1, 0.5, 1.2);
	madnes_add_sprite("megawin", "megawin", -9999, -9999, 1, 0.5, 1.2);
	madnes_add_sprite("supermegawin", "supermegawin", -9999, -9999, 1, 0.5, 0.8);
	
	madnes_add_bitmap_text("bigwin_text", "font_bigwin_mobile", -9999, -9999, "123456", 80);
	madnes_set_img_center("bigwin_text", 0.5, -0.6);
	
}

var info_pos_count = 4;
var infotable_count = 4;
var info_pos = 0;

var slideCallbackOnce = null;

let phaser = main_phaser;

var settings_background_pos;
export function mv81_infomenu_init()
{
	let top1 = 206;
	let top2 = 256;
	let shiftY = 214;

	phaser = wintable_phaser || main_phaser;

	var left = 590;
	
	settings_background_pos = 1;
	madnes_add_img("settings_background_1", "settings_background_1", 0, 0);
	madnes_add_img("settings_background_2", "settings_background_2", 0, 0);
	madnes_add_img("settings_background_3", "settings_background_3", 0, 0);
	madnes_add_img("settings_background_4", "settings_background_4", 0, 0);
	
	madnes_add_group("settings_group_1", phaser);
	madnes_add_to_group("settings_group_1", "settings_background_1");

	madnes_add_group("settings_group_2", phaser);
	madnes_add_to_group("settings_group_2", "settings_background_2");

	madnes_add_group("settings_group_3", phaser);
	madnes_add_to_group("settings_group_3", "settings_background_3");

	madnes_add_group("settings_group_4", phaser);
	madnes_add_to_group("settings_group_4", "settings_background_4");

	madnes_add_bitmap_text("seven_4", "font_wintables_mobile", left, top1, "100", 50);
	madnes_add_bitmap_text("seven_3", "font_wintables_mobile", left, top2, "20", 50);
	madnes_set_img_center("seven_4", 1, 0);
	madnes_set_img_center("seven_3", 1, 0);
	madnes_add_to_group("settings_group_1", "seven_4");
	madnes_add_to_group("settings_group_1", "seven_3");
	
	madnes_add_bitmap_text("grapes_4", "font_wintables_mobile", left, top1 + shiftY, "100", 50);
	madnes_add_bitmap_text("grapes_3", "font_wintables_mobile", left, top2 + shiftY, "20", 50);
	madnes_set_img_center("grapes_4", 1, 0);
	madnes_set_img_center("grapes_3", 1, 0);
	madnes_add_to_group("settings_group_1", "grapes_4");
	madnes_add_to_group("settings_group_1", "grapes_3");
	
	madnes_add_bitmap_text("melone_4", "font_wintables_mobile", left + 540, top1, "100", 50);
	madnes_add_bitmap_text("melone_3", "font_wintables_mobile", left + 540, top2, "20", 50);
	madnes_set_img_center("melone_4", 1, 0);
	madnes_set_img_center("melone_3", 1, 0);
	madnes_add_to_group("settings_group_1", "melone_4");
	madnes_add_to_group("settings_group_1", "melone_3");
	
	madnes_add_bitmap_text("bells_4", "font_wintables_mobile", left + 540, top1 + shiftY, "100", 50);
	madnes_add_bitmap_text("bells_3", "font_wintables_mobile", left + 540, top2 + shiftY, "20", 50);
	madnes_set_img_center("bells_4", 1, 0);
	madnes_set_img_center("bells_3", 1, 0);
	madnes_add_to_group("settings_group_1", "bells_4");
	madnes_add_to_group("settings_group_1", "bells_3");
	
	
	
	
	madnes_add_bitmap_text("plum_4", "font_wintables_mobile", left, top1, "100", 50);
	madnes_add_bitmap_text("plum_3", "font_wintables_mobile", left, top2, "20", 50);
	madnes_set_img_center("plum_4", 1, 0);
	madnes_set_img_center("plum_3", 1, 0);
	madnes_add_to_group("settings_group_2", "plum_4");
	madnes_add_to_group("settings_group_2", "plum_3");
	
	madnes_add_bitmap_text("orange_4", "font_wintables_mobile", left, top1 + shiftY, "100", 50);
	madnes_add_bitmap_text("orange_3", "font_wintables_mobile", left, top2 + shiftY, "20", 50);
	madnes_set_img_center("orange_4", 1, 0);
	madnes_set_img_center("orange_3", 1, 0);
	madnes_add_to_group("settings_group_2", "orange_4");
	madnes_add_to_group("settings_group_2", "orange_3");
	
	madnes_add_bitmap_text("dollar_4", "font_wintables_mobile", left + 540, top1, "100", 50);
	madnes_add_bitmap_text("dollar_3", "font_wintables_mobile", left + 540, top2, "20", 50);
	madnes_set_img_center("dollar_4", 1, 0);
	madnes_set_img_center("dollar_3", 1, 0);
	madnes_add_to_group("settings_group_2", "dollar_4");
	madnes_add_to_group("settings_group_2", "dollar_3");
	
	madnes_add_bitmap_text("cherry_4", "font_wintables_mobile", left + 540, top1 + shiftY, "100", 50);
	madnes_add_bitmap_text("cherry_3", "font_wintables_mobile", left + 540, top2 + shiftY, "20", 50);
	madnes_set_img_center("cherry_4", 1, 0);
	madnes_set_img_center("cherry_3", 1, 0);
	madnes_add_to_group("settings_group_2", "cherry_4");
	madnes_add_to_group("settings_group_2", "cherry_3");
	
	
	
	
	madnes_set_pos("settings_group_1", -9999, -9999);
	madnes_set_pos("settings_group_2", -9999, -9999);
	madnes_set_pos("settings_group_3", -9999, -9999);
	madnes_set_pos("settings_group_4", -9999, -9999);
	
	var infotext = madnes_get_json("infotext");
	
	for(var i in infotext)
	{
		var x = infotext[i].position[0];
		var y = infotext[i].position[1];
		var page = infotext[i].page;
		var lineHeight0 = infotext[i].lineHeight;
		var lineHeight1 = infotext[i].lineHeight;
		var x_add = 0;
		var center = 0;
		
		if(infotext[i].center && infotext[i].center == 1)
		{
			center = 1;
		}
		
		var style0 = {
				"font": "32px Arial",
				"fill": "#ffffff",
				"fontWeight": "",
			};
		var style1 = {
				"font": "32px Arial",
				"fill": "#ffffff",
				"fontWeight": "",
			};
		
		if(infotext[i].fontSize && infotext[i].font)
		{
			style0.font = infotext[i].fontSize + "px " + infotext[i].font;
			style1.font = infotext[i].fontSize + "px " + infotext[i].font;
		}
		if(infotext[i].color)
		{
			style0.fill = infotext[i].color;
			style1.fill = infotext[i].color;
		}
		if(infotext[i].bold)
		{
			if(infotext[i].bold == 1)
			{
				style0.fontWeight = "bold";
				style1.fontWeight = "bold";
			}
			else if(infotext[i].bold == 1)
			{
				style0.fontWeight = "";
				style1.fontWeight = "";
			}
		}
		
		if(infotext[i].title.fontSize && infotext[i].title.font)
		{
			style0.font = infotext[i].title.fontSize + "px " + infotext[i].title.font;
		}
		if(infotext[i].title.lineHeight)
		{
			lineHeight0 = infotext[i].title.lineHeight;
		}
		if(infotext[i].title.color)
		{
			style0.fill = infotext[i].title.color;
		}
		if(infotext[i].title.bold)
		{
			if(infotext[i].title.bold == 1)
			{
				style0.fontWeight = "bold";
			}
			else if(infotext[i].title.bold == 1)
			{
				style0.fontWeight = "";
			}
		}
		
		if(infotext[i].body.fontSize && infotext[i].body.font)
		{
			style1.font = infotext[i].body.fontSize + "px " + infotext[i].body.font;
		}
		if(infotext[i].body.color)
		{
			style1.fill = infotext[i].body.color;
		}
		if(infotext[i].body.lineHeight)
		{
			lineHeight1 = infotext[i].body.lineHeight;
		}
		if(infotext[i].body.bold)
		{
			if(infotext[i].body.bold == 1)
			{
				style1.fontWeight = "bold";
			}
			else if(infotext[i].body.bold == 1)
			{
				style1.fontWeight = "";
			}
		}
		if(infotext[i].body.x_add)
		{
			x_add = infotext[i].body.x_add;
		}
		
		var line0 = 0;
		var line1 = 0;
		
		for(var j in infotext[i].title.content)
		{
			var text = infotext[i].title.content[j];
			madnes_add_text("info_header_" + i + "_"  + j + "_" + line0, x, y + line0 * lineHeight0, text, style0);
			if(center == 1)
			{
				madnes_set_img_center("info_header_" + i + "_"  + j + "_" + line0, 0.5, 0);
			}
			madnes_add_to_group("settings_group_" + ( page * 1 + 1 ), "info_header_" + i + "_"  + j + "_" + line0);
			line0++;
		}
		
		for(var j in infotext[i].body.content)
		{
			var text = infotext[i].body.content[j];
			madnes_add_text("info_body_" + i + "_"  + j + "_" + line1, x * 1 + x_add * 1, y + line0 * lineHeight0 + line1 * lineHeight1, text, style1);
			if(center == 1)
			{
				madnes_set_img_center("info_body_" + i + "_"  + j + "_" + line1, 0.5, 0);
			}
			madnes_add_to_group("settings_group_" + ( page * 1 + 1 ), "info_body_" + i + "_"  + j + "_" + line1);
			line1++;
		}
	}
	
	mv81_infomenu_update();
}

export var openinfo = false;

export function mv81_infomenu_open()
{
	madnes_set_visible("settings_group_" + (info_pos + 1), true);
	madnes_set_pos("settings_group_" + (info_pos + 1), 0, 0);

	// settings_background_pos = 1;
	//
	// madnes_set_pos("settings_background_1", 0, 0);
	// madnes_set_pos("settings_background_2", 2500, 0);
	// madnes_set_pos("settings_background_3", 2500, 0);
	// madnes_set_pos("settings_background_4", 2500, 0);
	//
	// madnes_set_pos("settings_group_1", 0, 0);
	// madnes_set_pos("settings_group_2", 2500, 0);
	// madnes_set_pos("settings_group_3", 2500, 0);
	// madnes_set_pos("settings_group_4", 2500, 0);

	openinfo = true;
}

export function mv81_infomenu_close()
{
	for(var i = 0; i < infotable_count; i++)
	{
		madnes_set_pos("settings_group_" + (i + 1), -9999, -9999);
		madnes_set_visible("settings_group_" + (i + 1), false);
	}

	// madnes_set_pos("settings_background_1", -9999, -9999);
	// madnes_set_pos("settings_background_2", -9999, -9999);
	// madnes_set_pos("settings_background_3", -9999, -9999);
	// madnes_set_pos("settings_background_4", -9999, -9999);
	//
	// madnes_set_pos("settings_group_1", -9999, -9999);
	// madnes_set_pos("settings_group_2", -9999, -9999);
	// madnes_set_pos("settings_group_3", -9999, -9999);
	// madnes_set_pos("settings_group_4", -9999, -9999);

	openinfo = false;
}

export function mv81_infomenu_update()
{
	var max_wi = 180;
	madnes_set_bitmap_float("cherry_3", server_config.logic.symbols[0].factors[2] * bet, max_wi);
	madnes_set_bitmap_float("cherry_4", server_config.logic.symbols[0].factors[3] * bet, max_wi);
	
	madnes_set_bitmap_float("dollar_3", server_config.logic.symbols[1].factors[2] * bet, max_wi);
	madnes_set_bitmap_float("dollar_4", server_config.logic.symbols[1].factors[3] * bet, max_wi);
	
	madnes_set_bitmap_float("orange_3", server_config.logic.symbols[2].factors[2] * bet, max_wi);
	madnes_set_bitmap_float("orange_4", server_config.logic.symbols[2].factors[3] * bet, max_wi);
	
	madnes_set_bitmap_float("plum_3", server_config.logic.symbols[3].factors[2] * bet, max_wi);
	madnes_set_bitmap_float("plum_4", server_config.logic.symbols[3].factors[3] * bet, max_wi);
	
	madnes_set_bitmap_float("bells_3", server_config.logic.symbols[4].factors[2] * bet, max_wi);
	madnes_set_bitmap_float("bells_4", server_config.logic.symbols[4].factors[3] * bet, max_wi);
	
	madnes_set_bitmap_float("grapes_3", server_config.logic.symbols[5].factors[2] * bet, max_wi);
	madnes_set_bitmap_float("grapes_4", server_config.logic.symbols[5].factors[3] * bet, max_wi);
	
	madnes_set_bitmap_float("melone_3", server_config.logic.symbols[6].factors[2] * bet, max_wi);
	madnes_set_bitmap_float("melone_4", server_config.logic.symbols[6].factors[3] * bet, max_wi);
	
	madnes_set_bitmap_float("seven_3", server_config.logic.symbols[7].factors[2] * bet, max_wi);
	madnes_set_bitmap_float("seven_4", server_config.logic.symbols[7].factors[3] * bet, max_wi);
	
}

export function mv81_infomenu_left()
{
	if(!openinfo) {
		return;
	}

	menu_swipe(-1, info_pos - 1);
}

export function mv81_infomenu_right()
{
	if(!openinfo) {
		return;
	}

	menu_swipe(1, info_pos + 1);
}

export function mv81_infomenu_home() {
	if(info_pos == 0) {
		return;
	}

	if(!wt_swipe_lock) {
		menu_swipe(-1, 0);
	} else {
		slideCallbackOnce = () => {
			menu_swipe(-1, 0);
		}
	}
}

var wt_swipe_lock = false;
function menu_swipe(dir, next)
{
	if(wt_swipe_lock) {
		return false;
	}

	var prev_pos = info_pos;
	var info_pos_new = next; //info_pos + dir;

	if(info_pos_new > info_pos_count - 1) {
		info_pos_new = 0;
	}

	if(info_pos_new < 0) {
		info_pos_new = info_pos_count - 1;
	}

	info_pos = info_pos_new;

	madnes_set_pos("settings_group_" + (info_pos_new + 1), wi * dir, 0);

	let x = wi * dir;

	wt_swipe_lock = true;

	// madnes_move_to("settings_group_" + (info_pos), wi * dir * -1, null, 250);
	madnes_tween_to("settings_group_" + (prev_pos + 1), {x: wi * dir * -1}, {
		'duration': 250,
		'update': function (tween, perc) {

			madnes_set_pos_x("settings_group_" + (prev_pos + 1), x * -1 * perc);
			madnes_set_pos_x("settings_group_" + (info_pos_new + 1), x - (x * perc));
			// console.log(x.x, y, z);
		},
		'callback': () => {
			madnes_set_pos_x("settings_group_" + (prev_pos + 1), x * -1);
			madnes_set_pos_x("settings_group_" + (info_pos_new + 1), 0);

			wt_swipe_lock = false;

			slideCallbackOnce && slideCallbackOnce();
			slideCallbackOnce = null;

		}
	}, phaser);

	madnes_set_visible("settings_group_" + (info_pos_new + 1), true);
}

var mv81_infomenu_move_in = 0;
var mv81_infomenu_move_dir = 0;

var settings_background_pos2;
var mv81_infomenu_move_pos;

// function mv81_infomenu_move()
// {
// 	var difftime = madnes_get_currtime() - move_start;
// 	var end = 0;
// 	if(difftime > move_total)
// 	{
// 		difftime = move_total;
// 		end = 1;
// 	}
//
// 	settings_background_pos2 = settings_background_pos * 1 + ( mv81_infomenu_move_dir * -1);
// 	if(settings_background_pos2 > 4)
// 	{
// 		settings_background_pos2 = 1;
// 	}
// 	if(settings_background_pos2 < 1)
// 	{
// 		settings_background_pos2 = 4;
// 	}
//
// 	var pos1 = wi * ( ( ( 100 / move_total ) * difftime ) / 100 ) * mv81_infomenu_move_dir;
// 	if(mv81_infomenu_move_dir < 0)
// 	{
// 		var pos2 = pos1 + wi;
// 	}
// 	else
// 	{
// 		var pos2 = wi * -1 + pos1;
// 	}
//
// 	madnes_set_pos_x("settings_background_" + settings_background_pos, pos1, 0);
// 	madnes_set_pos_x("settings_background_" + settings_background_pos2, pos2, 0);
//
// 	madnes_set_pos_x("settings_group_" + settings_background_pos, pos1, 0);
// 	madnes_set_pos_x("settings_group_" + settings_background_pos2, pos2, 0);
//
// 	if(end == 1)
// 	{
// 		madnes_rem_from_render(mv81_infomenu_move);
//
// 		madnes_set_pos_x("settings_background_" + settings_background_pos2, 0, 0);
// 		madnes_set_pos_x("settings_background_" + settings_background_pos, 2500, 0);
//
// 		madnes_set_pos_x("settings_group_" + settings_background_pos2, 0, 0);
// 		madnes_set_pos_x("settings_group_" + settings_background_pos, 2500, 0);
//
// 		settings_background_pos = settings_background_pos2;
// 		mv81_infomenu_move_in = 0;
// 		mv81_infomenu_move_dir = 0;
// 		mv81_infomenu_move_pos = 0;
// 	}
// }

